import { PpfRouteData } from "@ppf/shared/data";

const baseRoute = "programs";

export const gridServiceLeadIdParameter = ":gridServiceLeadId";

export const PROGRAMS_ROUTE_DATA: PpfRouteData<
	"base" | "eligible" | "success" | "enrolled" | "sign" | "signed"
> = {
	base: {
		route: baseRoute,
		fullRoute: `/${baseRoute}`,
	},
	eligible: {
		route: "eligible",
		fullRoute: `/${baseRoute}/eligible`,
	},
	success: {
		route: "success",
		fullRoute: `/${baseRoute}/success`,
	},
	enrolled: {
		route: "enrolled",
		fullRoute: `/${baseRoute}/enrolled`,
	},
	sign: {
		route: "sign",
		fullRoute: `/${baseRoute}/sign`,
	},
	signed: {
		route: "signed",
		fullRoute: `/${baseRoute}/signed`,
	},
};
